import Store from '../store';
import jwtDecode from 'jwt-decode';
import cookie from 'react-cookies';
import { ImmortalStorage, CookieStore, LocalStorageStore } from 'immortal-db';
import { setFetchServiceToken} from './FetchService';




import {
  appSetLoginData,
  logout,
}
  from '../actions/appAction';



export const LOGIN_DATA             = 'LoginData';
export const LOGOUT                 = 'LogOut';
export const FIRST_TIME_VISIT_DATA  = 'FirstTimeVisitData';

const stores = [CookieStore, LocalStorageStore];
const db = new ImmortalStorage(stores);


/* ---  --------------- --- */
/* ---  Login / Logout  --- */
/* ---  --------------- --- */
export async function appLogin(token,userData)
{
  userData.token = token;
  var dataString = JSON.stringify(userData);

  await db.set(LOGIN_DATA, token);
  Store.dispatch(appSetLoginData(token,userData));
  setFetchServiceToken(token);
  return dataString;
}


export async function appLogout(callback)
{
  db.remove(LOGIN_DATA);
  Store.dispatch(logout());
  return true;
}

export function getAuthorizationData()
{

  var  rawData = cookie.load(LOGIN_DATA);
  var data = JSON.parse(rawData);

  return data;
}